const handleFormSuccess = (
  { enqueueSnackbar },
  message = 'Updated successfully',
) => {
  enqueueSnackbar(message, { variant: 'success' });
};

export default handleFormSuccess;
